// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { SagaSystemMessage_abstract } from './../../abstract/SagaBase/Objects/SagaSystemMessage_abstract';
export class SagaSystemMessage extends SagaSystemMessage_abstract {}
